import ApplicationSerializer from 'teacher-ui-client/serializers/application'
import type Store from '@ember-data/store'

export default class RolloverImportScheduleSerializer extends ApplicationSerializer {
  normalizeSingleResponse(
    store: Store,
    primaryModelClass: any, // This is really ModelSchema, but definitely typed doesn't properly expose this interface
    payload: object & { data?: { type?: unknown } },
    id: string | number,
    requestType: string,
  ) {
    if (payload?.data?.type) payload.data.type = 'rollover-import-schedules'
    return super.normalizeSingleResponse(store, primaryModelClass, payload, id, requestType)
  }
}
